declare var jQuery: any;

export class SpinnerController {
    public toggleSpinnerOnButton(button_element: any, on_off: any = undefined) {
        if (jQuery(button_element).find('.temp_spinner').length == 0) {
            const spinner = `<span class="temp_spinner" style="display:flex">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" stroke="#2196F3" viewBox="0 0 24 24"><script xmlns=""/><style>.spinner_QPB9{transform-origin:center;animation:spinner_4N1C 2s linear infinite}.spinner_QPB9 circle{stroke-linecap:round;animation:spinner_MX3P 1.5s ease-in-out infinite}@keyframes spinner_4N1C{100%{transform:rotate(360deg)}}@keyframes spinner_MX3P{0%{stroke-dasharray:0 150;stroke-dashoffset:0}47.5%{stroke-dasharray:42 150;stroke-dashoffset:-16}95%,100%{stroke-dasharray:42 150;stroke-dashoffset:-59}}</style><g class="spinner_QPB9"><circle cx="12" cy="12" r="9.5" fill="none" stroke-width="3"/></g><script xmlns=""/><script xmlns=""/></svg>
            </span>`;
            jQuery(button_element).append(spinner);
        }

        const temp_spinner = jQuery(button_element).find('.temp_spinner');
        if (on_off) {
            jQuery(button_element).addClass('vm-spinner-wrap');
            jQuery(temp_spinner).show();
            setTimeout(() => {
                jQuery(button_element).attr('disabled', 'disabled');
            }, 100);
        } else {
            jQuery(button_element).removeClass('vm-spinner-wrap');
            jQuery(temp_spinner).hide();
            setTimeout(() => {
                jQuery(button_element).removeAttr('disabled');
            }, 100);
        }
    }

    public addLoadingOverlay() {
        const loadingOverlay = jQuery('#loading-overlay');
        
        if (loadingOverlay.length > 0) {
            loadingOverlay.css('display', 'flex');
        } else {
            const overlay = `
                <div id="loading-overlay" style="display: flex;">
                    <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100" stroke="#2196F3" viewBox="0 0 24 24">
                        <style>
                            .spinner_QPB9 {
                                transform-origin: center;
                                animation: spinner_4N1C 2s linear infinite;
                            }
                            .spinner_QPB9 circle {
                                stroke-linecap: round;
                                animation: spinner_MX3P 1.5s ease-in-out infinite;
                            }
                            @keyframes spinner_4N1C {
                                100% {
                                    transform: rotate(360deg);
                                }
                            }
                            @keyframes spinner_MX3P {
                                0% {
                                    stroke-dasharray: 0 150;
                                    stroke-dashoffset: 0;
                                }
                                47.5% {
                                    stroke-dasharray: 42 150;
                                    stroke-dashoffset: -16;
                                }
                                95%, 100% {
                                    stroke-dasharray: 42 150;
                                    stroke-dashoffset: -59;
                                }
                            }
                        </style>
                        <g class="spinner_QPB9">
                            <circle cx="12" cy="12" r="9.5" fill="none" stroke-width="3"/>
                        </g>
                    </svg>
                </div>
            `;
            jQuery('body').prepend(overlay);
        }
    }
    

    public removeLoadingOverlay() {
        const loadingOverlay = jQuery('#loading-overlay');
        loadingOverlay.css('display', 'none');
    }
}
